import { defineFeatures } from "../define-provider-capability";

/**
 * The `stripe` features the mobile service selects. The app's bundle
 * carries these through `@libs/environment-client-contracts/mobile`, not the rest of
 * the capability, so a server-only change to it does not change the app.
 */
export const stripeMobileFeatures = defineFeatures({
  // Apple/Google Pay merchant identifier baked into the mobile bundle.
  mobilePayments: {
    scope: "runtime",
    environments: {
      local: { mode: "managed" },
      preview: { mode: "managed" },
      production: { mode: "managed" },
    },
    env: [
      {
        name: "EXPO_PUBLIC_STRIPE_MERCHANT_IDENTIFIER",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "environment" },
      },
    ],
  },
});
